import { render, staticRenderFns } from "./generic.vue?vue&type=template&id=4349a522&scoped=true&"
import script from "./generic.vue?vue&type=script&lang=js&"
export * from "./generic.vue?vue&type=script&lang=js&"
import style0 from "./generic.vue?vue&type=style&index=0&id=4349a522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4349a522",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/app/components/navigation/Navbar.vue').default,HeaderGroup: require('/app/components/header/HeaderGroup.vue').default,Footer: require('/app/components/Footer.vue').default})
